import * as _ from 'lodash'
import { Button, all } from 'alkali'
import { invalid } from 'components/extract/Inputs'
import { notEmptyArrayFn } from './model/validation'
import Dropdown, { getMultiselectItems } from 'components/generic/Dropdown'

//const getDesigns = _.memoize(() => get('/api/lookuptable/search?EnumIds=72&Select=Name').then((results = []) => results.map(({Name}) => Name)))
const DESIGNS = [
	'Randomized Controlled Trial',
	'Interventional, Other',
	'Prospective Observational',
	'Retrospective Observational',
	'Observational, Other',
	'Posthoc Analysis'
]

const DESIGN_LABELS = {
	'Posthoc Analysis': 'Post hoc Analysis'
}

const getDesigns = () => Promise.resolve(DESIGNS)

const designLabel = design => DESIGN_LABELS[design] || design
const designOptions = (designs: string[]) =>
	_.sortBy(_.uniq(designs).map(design => ({ label: designLabel(design), field: design })), item => item.label)

export default class StudyDesignButton extends Button('.design-type.clickable') {
	created(props) {
		const designs = props.designs
		const invld = invalid(designs, designs.to(notEmptyArrayFn))
		Object.assign(props, {
			title: all([designs, invld], (arr, invalid) =>
				arr?.length > 0 ? arr.join(', ')
	                         : (invalid ? 'Please select design' : 'Designs')
			),
			type: 'button',
			classes: {
				'invalid-field': invld
			},
			onclick(e) {
				const target = e.currentTarget
				Promise.resolve().then(() =>
					designDropdown || Promise.all([props.designs, getDesigns()]).then(([current, designs]) => {
						return designDropdown = new Dropdown({
							items: getMultiselectItems(designOptions((current || []).concat(designs)), props.designs)
						})
					})
				).then(dropdown => dropdown.show(e, target))
			}
		})
		let designDropdown
		props.content = designs.to(arr => arr?.length > 0 ? arr.map(designLabel).join(', ') : 'Design')
	}
}